<template>
  <div class="repair-detail-page">
    <div class="repair-detail-card">
      <div class="detail-header">
        <div class="detail-title-group">
          <span class="detail-parent">工单池</span>
          <span class="detail-arrow">/</span>
          <span class="detail-title">工单详情</span>
        </div>
        <el-button size="small" class="detail-back-btn" @click="goBack">返回</el-button>
      </div>

      <div class="detail-info-panel">
        <div v-for="item in detailFields" :key="item.label" class="detail-field">
          <span class="detail-label">{{ item.label }}：</span>
          <span class="detail-value">{{ item.value || '-' }}</span>
        </div>
      </div>

      <!-- 告警图片 -->
      <div class="detail-image-section">
        <div class="section-title">告警图片</div>
        <div v-if="alarmImages.length === 0" class="empty-tip">暂无图片</div>
        <div v-else class="image-list">
          <el-image
            v-for="(img, index) in alarmImages"
            :key="'alarm-' + index"
            class="detail-image"
            :src="img"
            :preview-src-list="alarmImages"
            fit="cover"
          />
        </div>
      </div>

      <!-- 处理图片 -->
      <div class="detail-image-section">
        <div class="section-title">处理图片</div>
        <div v-if="handleImages.length === 0" class="empty-tip">暂无图片</div>
        <div v-else class="image-list">
          <el-image
            v-for="(img, index) in handleImages"
            :key="'handle-' + index"
            class="detail-image"
            :src="img"
            :preview-src-list="handleImages"
            fit="cover"
          />
        </div>
      </div>

      <!-- 底部按钮在白色卡片内，右对齐 -->
      <div class="detail-footer-actions">
        <el-button type="primary" class="detail-confirm-btn" @click="handleConfirm">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getInspectionWorkDetail } from '@/api/inspection/workPoolDetailApi'

export default {
  name: 'WorkPoolDetail',
  data() {
    return {
      loading: false,
      workDetail: {}
    }
  },
  computed: {
    detailFields() {
      const d = this.workDetail
      return [
        { label: '所在小区', value: d.communityName },
        { label: '工单编码', value: d.workNo },
        { label: '设备信息', value: d.deviceInfo || d.deviceNo },
        { label: '联系位置', value: d.location },
        { label: '告警类型', value: d.alarmType },
        { label: '告警级别', value: d.alarmLevelName || this.mapAlarmLevel(d.alarmLevel) },
        { label: '告警名称', value: d.alarmName },
        { label: '告警时间', value: d.alarmTime },
        { label: '描述', value: d.description },
        { label: '状态', value: d.stateName },
        { label: '处理人员', value: d.handlerName || d.handler },
        { label: '实际处理人', value: d.actualHandlerName || d.realHandlerName },
        { label: '处理时间', value: d.handleTime || d.finishTime || d.actualTime },
        { label: '结束原因', value: d.endContext }
      ]
    },
    alarmImages() {
      return Array.isArray(this.workDetail.alarmImages) ? this.workDetail.alarmImages : []
    },
    handleImages() {
      return Array.isArray(this.workDetail.handleImages) ? this.workDetail.handleImages : []
    }
  },
  mounted() {
    this.loadDetail()
  },
  methods: {
    async loadDetail() {
      const id = this.$route.query.id
      if (!id) {
        this.$message.error('工单ID缺失，无法加载详情')
        this.$router.back()
        return
      }
      this.loading = true
      try {
        const data = await getInspectionWorkDetail(id)
        this.workDetail = data
      } catch (error) {
        this.$message.error(error.message || '加载工单详情失败')
      } finally {
        this.loading = false
      }
    },
    goBack() {
      this.$router.back()
    },
    handleConfirm() {
      this.goBack()
    },
    mapAlarmLevel(level) {
      const map = { HIGH: '高', MEDIUM: '中', LOW: '低' }
      return map[level] || level
    }
  }
}
</script>

<style scoped>
.repair-detail-page { min-height: 100%; padding: 0 24px 24px; background: #EBF2FA; }
.repair-detail-card { background: #FFFFFF; border-radius: 12px; padding: 20px 24px 24px; }
.detail-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 28px; }
.detail-title-group { display: flex; align-items: center; gap: 12px; font-family: 'PingFang SC'; font-size: 16px; }
.detail-parent { color: #8C9BB4; }
.detail-arrow { color: #C9CDD4; }
.detail-title { color: #1D2129; font-weight: 500; }
.detail-back-btn { width: 76px; height: 36px; padding: 0; border-radius: 10px; border: 1px solid #0E76FF; color: #0E76FF; background: #FFFFFF; }
.detail-info-panel { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 24px 32px; margin-bottom: 32px; }
.detail-field { display: flex; font-size: 14px; line-height: 22px; }
.detail-label { color: #6A7282; min-width: 80px; flex-shrink: 0; }
.detail-value { color: #1D2129; word-break: break-all; }
.detail-image-section { margin-top: 32px; padding-top: 32px; border-top: 1px solid #E5E8EF; }
.detail-image-section:first-of-type { margin-top: 0; padding-top: 0; border-top: none; }
.section-title { font-size: 15px; font-weight: 600; color: #1D2129; margin-bottom: 16px; }
.image-list { display: flex; gap: 16px; flex-wrap: wrap; }
.detail-image { width: 120px; height: 120px; border-radius: 8px; overflow: hidden; cursor: pointer; }
.empty-tip { color: #8C9BB4; font-size: 14px; padding: 20px 0; width: 100%; }
.detail-footer-actions { display: flex; justify-content: flex-end; padding-top: 32px; margin-top: 32px; border-top: 1px solid #E5E8EF; }
.detail-confirm-btn { width: 120px; height: 38px; padding: 0; border-radius: 10px; background: #0E76FF; border-color: #0E76FF; font-weight: 500; }
@media (max-width: 1400px) { .detail-info-panel { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
@media (max-width: 900px) { .repair-detail-page { padding: 0 12px 16px; } .detail-info-panel { grid-template-columns: 1fr; } }
</style>
